module.exports = __webpack_public_path__ + "static/media/SV1_03_Protection_1000.125a2aba.jpg";